import { render, staticRenderFns } from "./ResumeExistingSessionModal.vue?vue&type=template&id=34bef466"
import script from "./ResumeExistingSessionModal.vue?vue&type=script&lang=js"
export * from "./ResumeExistingSessionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports